import React, { useState, useEffect } from "react";
import { db, storage } from "../firebase";
import { collection, getDocs, addDoc } from "firebase/firestore";
import Slider from "react-slick";
import { Box, Typography, TextField, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Rating from "@mui/material/Rating";
import TestimonialSlider from "./TestimonialSlider";
import { getDownloadURL, listAll, ref } from "firebase/storage";

const ReviewsSection = () => {
  const [reviews, setReviews] = useState([]);
  const [reviewContent, setReviewContent] = useState("");
  const [reviewName, setReviewName] = useState("");
  const [reviewRating, setReviewRating] = useState(5);
  const { t } = useTranslation();
  const [imageUrls, setImageUrls] = useState({
    heroImages: "",
    aboutImage: "",
    iconicImage: "",
    testimonialBackgrounds: [],
    appointmentImage: "",
  });
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "patientReviews"));
        const reviewsData = querySnapshot.docs.map((doc) => doc.data());
        setReviews(reviewsData.filter((review) => review.isVisible));
      } catch (error) {
        console.error("Error fetching reviews from Firestore:", error);
      }
    };

    fetchReviews();
  }, []);
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const homeRef = ref(storage, "home");
        const listResult = await listAll(homeRef);

        const urls = await Promise.all(
          listResult.items.map((item) => getDownloadURL(item))
        );

        setImageUrls((prevState) => ({
          ...prevState,
          heroImage1: urls.find((url) =>
            url.includes(
              "ophthalmologist-examining-woman-with-optometrist-trial-frame-female-patient-check-vision-ophthalmological-clinic"
            )
          ),
          heroImage2: urls.find((url) =>
            url.includes("woman-getting-eye-exam")
          ),
          centerImage: urls.find((url) =>
            url.includes("front-view-woman-getting-her-eyes-checked_23")
          ),
          aboutImage: urls.find((url) => url.includes("2024-10-17")),
          iconicImage: urls.find((url) => url.includes("iconic")),
          testimonial1: urls.find((url) =>
            url.includes("patient-ophthalmologist-s-office_23")
          ),
          testimonial2: urls.find((url) =>
            url.includes("doctor-preparing-ophthalmologist-s-office_23")
          ),
          testimonialBackgrounds: urls.filter((url) =>
            url.includes("testimonial")
          ),
          appointmentImage: urls.find((url) => url.includes("appointment")),
        }));
      } catch (error) {
        console.error("Error fetching images: ", error);
      }
    };

    fetchImages();
  }, []);
  const handleAddReview = async () => {
    if (!reviewContent || !reviewName || reviewRating === null) {
      alert(t("reviewsSection.allFieldsRequired"));
      return;
    }

    try {
      await addDoc(collection(db, "patientReviews"), {
        description: reviewContent,
        name: reviewName,
        ratings: reviewRating,
        createdAt: new Date(),
        isVisible: true,
      });
      setReviewContent("");
      setReviewName("");
      setReviewRating(5);
      alert(t("reviewsSection.reviewAdded"));
    } catch (error) {
      console.error("Error adding review:", error);
    }
  };

  return (
    <section className="reviews-section section-gap">
      {/* Display reviews using the TestimonialSlider */}
      <section
        className="testimonial-section testimonial-two-bg section-gap bg-color-primary"
        style={{
          backgroundColor: "var(--color-fourth)",
        }}
      >
        <div className="container">
          <div className="testimonial-slider-three">
            <div className="row justify-content-center">
              <TestimonialSlider reviews={reviews} />
            </div>
            <div className="slider-arrows" />
          </div>
        </div>{" "}
        <div
          className="bg-two"
          style={{
            backgroundImage: `url(${imageUrls.testimonial1})`,
          }}
          loading="lazy"
        />
        <div
          className="bg-one"
          style={{
            backgroundImage: `url(${imageUrls.testimonial2})`,
          }}
          loading="lazy"
        />
      </section>{" "}
    </section>
  );
};

export default ReviewsSection;
